module.exports = __webpack_public_path__ + "static/media/airship-back.37f02acd.png";